import React from "react";
import './claimspage.css'

export default function Toast({ visible, message, type = "info" }) {
  if (!message) return null;

  return (
    <div
      className={`samudra-toast ${type} ${visible ? "show" : ""}`}
      role="status"
      aria-live="polite"
    >
      <div className="toast-message">{message}</div>
    </div>
  );
}

